import React, { useEffect, useState } from 'react';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import Courses from '../Courses/Courses';

import './Home.css'
import { Card } from 'react-bootstrap';

const Home = () => {
    const [courses, setCourses] = useState([]);
    useEffect(() => {
        fetch('./data.json')
            .then(res => res.json())
            .then(data => setCourses(data));
    }
        , []);
    return (
        <div>
            <h2 sx={{ backgroundColor: 'success', py: 2 }} className="text-center">Welcome to Learn With Fun</h2>
            <div>
                <Card border="primary" className="courses p-3 m-3 rounded">
                    {
                        courses.map(course => <Courses
                            key={course.id}
                            course={course}
                        />)
                    }

                </Card>
            </div>
        </div>
    );
};

export default Home;